/*
 * January Moon — main PDP image prev/next arrows.
 *
 * The big gallery image has left/right arrows (.jm-gallery-arrow). They do NOT
 * scroll the main slider — instead they move the thumbnail selection one step
 * back/forward by clicking the previous/next thumbnail button. Dawn's
 * media-gallery.js then switches the main image and scrolls the active
 * thumbnail into view, so the arrows effectively drive the thumbnail nav.
 *
 * The thumbnail strip's own prev/next arrows stay hidden (jm-thumbnail-drag.css).
 * Idempotent — safe to run again on shopify:section:load.
 */
(function () {
  // Visible thumbnail <li>s in DOM order (skips variant-hidden ones).
  function thumbItems(gallery) {
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!thumbs) return [];
    return Array.prototype.filter.call(
      thumbs.querySelectorAll('li[data-target]'),
      function (li) {
        return li.offsetParent !== null; // visible only
      }
    );
  }

  // Index of the currently active thumbnail (button[aria-current="true"]).
  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) {
      var btn = list[i].querySelector('button[aria-current="true"]');
      if (btn) return i;
    }
    return 0;
  }

  function go(gallery, dir) {
    var list = thumbItems(gallery);
    if (list.length < 2) return;
    var next = (activeIndex(list) + dir + list.length) % list.length; // wrap around
    var btn = list[next].querySelector('button');
    if (btn) btn.click();
  }

  function init(gallery) {
    if (gallery.dataset.jmNavReady === "1") return;
    gallery.dataset.jmNavReady = "1";
    gallery.querySelectorAll(".jm-gallery-arrow").forEach(function (arrow) {
      arrow.addEventListener("click", function () {
        go(gallery, parseInt(arrow.dataset.dir, 10) || 1);
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll("media-gallery").forEach(init);
  }

  if (document.readyState !== "loading") {
    initAll();
  }
  document.addEventListener("DOMContentLoaded", function () {
    initAll();
  });
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
